/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Challenge_Not_Yet_Started_TitleInputs */

const en_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Starts Soon`)
};

const ar_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيبدأ الحدث قريبًا`)
};

const de_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event startet bald`)
};

const es_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento empieza pronto`)
};

const fr_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’événement commence bientôt`)
};

const it_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento inizierà presto`)
};

const ja_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントまもなく開始`)
};

const ko_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트가 곧 시작됩니다`)
};

const pt_br_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento começa em breve`)
};

const ru_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие скоро начнется`)
};

const th_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมจะเริ่มเร็ว ๆ นี้`)
};

const tr_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik Yakında Başlıyor`)
};

const zh_cn_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动即将开始`)
};

const zh_tw_challenge_not_yet_started_title = /** @type {(inputs: Challenge_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動即將開始`)
};

/**
* | output |
* | --- |
* | "Event Starts Soon" |
*
* @param {Challenge_Not_Yet_Started_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const challenge_not_yet_started_title = /** @type {((inputs?: Challenge_Not_Yet_Started_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Challenge_Not_Yet_Started_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_challenge_not_yet_started_title(inputs)
	if (locale === "ar") return ar_challenge_not_yet_started_title(inputs)
	if (locale === "de") return de_challenge_not_yet_started_title(inputs)
	if (locale === "es") return es_challenge_not_yet_started_title(inputs)
	if (locale === "fr") return fr_challenge_not_yet_started_title(inputs)
	if (locale === "it") return it_challenge_not_yet_started_title(inputs)
	if (locale === "ja") return ja_challenge_not_yet_started_title(inputs)
	if (locale === "ko") return ko_challenge_not_yet_started_title(inputs)
	if (locale === "pt_br") return pt_br_challenge_not_yet_started_title(inputs)
	if (locale === "ru") return ru_challenge_not_yet_started_title(inputs)
	if (locale === "th") return th_challenge_not_yet_started_title(inputs)
	if (locale === "tr") return tr_challenge_not_yet_started_title(inputs)
	if (locale === "zh_cn") return zh_cn_challenge_not_yet_started_title(inputs)
	return zh_tw_challenge_not_yet_started_title(inputs)
});